//车场管理
const ParkingParklist = () => import(/*webpackChunkName:'operation'*/"@/page/operation/parkingManagement/parklist.vue")
const AbnormalRelease = () => import(/*webpackChunkName:'operation'*/"@/page/operation/parkingManagement/abnormalRelease.vue")
const ParkingIORecordList = () => import(/*webpackChunkName:'operation'*/"@/page/operation/parkingManagement/ioRecordList.vue")
const PresenceRecord = () => import(/*webpackChunkName:'operation'*/"@/page/operation/parkingManagement/presenceRecord.vue")


const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const parkingManagement=
    {
        path: '/main/park',
        name: '车场管理',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/park/iorecordlist',
            name: '进出记录',
            meta: {
                requireAuth: true,
            },
            component: ParkingIORecordList
        },
        {
            path: '/main/park/parkingParklist',
            name: '车场管理',
            meta: {
                requireAuth: true,
            },
            component: ParkingParklist
        },
        {
            path: '/main/park/presenceRecord',
            name: '在场记录',
            meta: {
                requireAuth: true,
            },
            component: PresenceRecord
        },

        {
            path: '/main/park/abnormalRelease',
            name: '异常放行记录',
            meta: {
                requireAuth: true,
            },
            component: AbnormalRelease
        },
        ]
    }
